/** @format */

import React, { useState, useMemo } from 'react';
// @ts-ignore
import {
  LanguageSelector,
  Menu,
  ResponsiveMenu,
  LogosContainer,
} from '@components';
import { useWindowSize } from '@hooks';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useStateContext } from '@context';
import type { StateContextProps, DataContextProps } from '@context';
import { Link } from 'gatsby';
import { useSiteData } from '@context';

/**
 * Header.
 */
const Header = (): JSX.Element => {
  const [stickyMenu, setStickyMenu] = useState<boolean>(false);
  const [showStickyMenu, setShowStickyMenu] = useState<boolean>(false);
  const { responsiveMenuOpen, setResponsiveMenuOpen }: StateContextProps =
    useStateContext();
  const { width } = useWindowSize();
  const { siteData }: DataContextProps = useSiteData();
  const language = siteData?.currentLocale ?? 'en';

  /**
   * Use Scroll Position.
   */
  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (width < 1280) {
        const isSticky = currPos.y * -1 >= 20;
        if (isSticky !== stickyMenu) {
          setStickyMenu(isSticky);
        }
        const isShowing = currPos.y > prevPos.y;
        if (isShowing !== showStickyMenu) {
          setShowStickyMenu(isShowing);
        }

        if (responsiveMenuOpen) {
          setResponsiveMenuOpen(false);
        }
      } else {
        setShowStickyMenu(false);
        setStickyMenu(false);
      }
    },
    [stickyMenu, showStickyMenu],
    undefined,
    false,
    300
  );

  /**
   * Render.
   */
  return useMemo(
    () => (
      <header
        className={`header-wrapper ${stickyMenu ? `sticky-menu` : ``} ${showStickyMenu ? `show-sticky-menu` : ``}`}
      >
        <div className="header-container container large">
          {width >= 1280 ? (
            <>
              <LogosContainer />
              <Menu />
            </>
          ) : (
            <>
              <ResponsiveMenu />
              <LogosContainer />
              <div className="language-selector-top-navigation">
                <ul className="language-selector-top-navigation-list">
                  <li className="top-navigation-item search">
                    <Link to={`/${language}/search`}>
                      <i className="icon-search" />
                    </Link>
                  </li>
                  <LanguageSelector selectorType="top-bar" />
                </ul>
              </div>
            </>
          )}
        </div>
      </header>
    ),
    [stickyMenu, showStickyMenu, width]
  );
};
export default Header;
